const s = {
  name: "Drinks",
  dimensions: { width: 36, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 36 40" style="enable-background:new 0 0 36 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M16,0H0v20c0,4.1,3.1,7.4,7,7.9V38H0v2h16v-2H9V27.9c3.9-0.5,7-3.9,7-7.9V0z M2,7V2h12v5H2z M2,9h12v11
			c0,3.3-2.7,6-6,6c-3.3,0-6-2.7-6-6V9z"/>
		<path class="st0" d="M20,0h16v20c0,4.1-3.1,7.4-7,7.9V38h7v2H20v-2h7V27.9c-3.9-0.5-7-3.9-7-7.9V0z M22,9v11c0,3.3,2.7,6,6,6
			s6-2.7,6-6V9H22z M22,7h12V2H22V7z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Drinks
};
